import { useLayoutEffect, useRef, type ReactNode } from "react";

/** 조회가 끝날 때까지 직전 화면을 유지한다. 남아 있는 화면의 쓰기 동작은 막는다. */
export function RetainedContent({ ready, children }: { ready: boolean; children: ReactNode }) {
  const previous = useRef<ReactNode>(null);
  useLayoutEffect(() => { if (ready) previous.current = children; }, [ready, children]);
  return <div aria-busy={!ready || undefined} inert={!ready}>
    {ready ? children : previous.current}
  </div>;
}
